import { Component, OnInit } from '@angular/core';

import {
  DwComponent,
  DwComponentType,
  DwDataSort,
  DwGridColumnPreference,
  DwMdDataActionResult,
  DwMetaDataFilterTileState
} from '@devwareapps/devware-cap';

import { AppMetaData, ManageUsersQueryEntity } from '../../../../../meta-data/app-meta-data.service';
import { DwAviatorGridRendererBaseComponent } from '../dw-aviator-grid-renderer-base.component';

@DwComponent({
  key: 'users-grid-renderer-prototype',
  name: 'Users Grid Renderer - Prototype',
  isGlobal: false,
  parentItemName: AppMetaData.DwUser.ItemDetail.itemName,
  componentType: DwComponentType.gridRenderer
})
@Component({
  selector: 'app-users-grid-renderer-prototype',
  templateUrl: './users-grid-renderer-prototype.component.html',
  styleUrls: ['./users-grid-renderer-prototype.component.scss']
})
export class UsersGridRendererPrototypeComponent
  extends DwAviatorGridRendererBaseComponent<ManageUsersQueryEntity>
  implements OnInit {
  
  
  public sortField: string = 'UserDetailUserIdDisplay';
  public sortDescending: boolean = false;

  ngOnInit(): void {
  }

  setupRenderer(): void {
    
  }
  
  protected filterTileStateChange(filterTileState: DwMetaDataFilterTileState): void {
    
  }

  setupRendered(): void {
    this.applyCurrentSort();
  }

  customFiltersChanged(): void {
   
  }

  processDataActionResult(dataActionResult: DwMdDataActionResult): void {
  }

  public toggleNameSort(): void {
    if (this.sortField === 'UserDetailUserIdDisplay') {
      this.sortDescending = !this.sortDescending;
    } else {
      this.sortField = 'UserDetailUserIdDisplay';
      this.sortDescending = false;
    }

    this.applyCurrentSort();
  }

  public refresh(): void {
    this.refreshDataSource();
  }

  public getSortIcon(): string {
    if (this.sortField !== 'UserDetailUserIdDisplay') {
      return '';
    }

    return this.sortDescending ? '▼' : '▲';
  }

  public trackByUser(index: number, item: ManageUsersQueryEntity): string | number {
    return item.UserKey || item.UserId || index;
  }

  protected resolveInitialPageSize(): number {
    return 20;
  }

  protected getEffectiveSorts(): DwDataSort[] {
    if (!this.sortField) {
      return [];
    }

    return [
      {
        fieldName: this.sortField,
        ascending: !this.sortDescending
      } as DwDataSort
    ];
  }

  private applyCurrentSort(): void {
    this.setSorts(this.getEffectiveSorts());
  }
}